export enum ReviewType {
    ManualCreateAsNeeded = 1,
    AutoGenerateOnePerCase = 2,
    AutoGenerateOnePerCaseAssignment = 3,
    AutoGenerateOnePerTaskOrAssigment = 4
}